import React, {useEffect, useRef} from "react";
import UserPageHeader from "../../../Components/Sends/Controls/UserPageHeader";
import UserPageFooter from "../../../Components/Sends/Controls/UserPageFooter";
import SendsHistoryControl from "../../../Components/Sends/Controls/SendsHistoryControl";
import {useUser} from "../../../Api/UsersEndpoints";
import SendMailHistoryProvider from "../../../Providers/SendMailHistoryProvider";

const UserSendsHistory = () => {
    const { data } = useUser();
    const sendsHistoryRef = useRef<any>();

    useEffect(() => {
        document.title = 'History | UK Postbox';
    }, []);

    return (
        <SendMailHistoryProvider userId={data?.id}>
            <div className={'inner-content'}>
                <div className='container' ref={sendsHistoryRef}>
                    <UserPageHeader />

                    <div className={'row mt-sm mb-xl'}>
                        <div className={'col-xs-12 col-center-lg-10 col-center-xl-8'}>
                            <div className={'card'}>
                                <SendsHistoryControl containerRef={sendsHistoryRef} forceHeader={true} />
                            </div>
                        </div>
                    </div>

                    <UserPageFooter />
                </div>
            </div>
        </SendMailHistoryProvider>
    )
}

export default UserSendsHistory